// ⚡ SYSTÈME DE CACHE POUR OPTIMISATION PERFORMANCE
const cache = {
  data: {},
  timestamps: {},
  CACHE_DURATION: 5 * 60 * 1000, // 5 minutes
  
  set(key, value) {
    this.data[key] = value;
    this.timestamps[key] = Date.now();
  },
  
  get(key) {
    const timestamp = this.timestamps[key];
    if (!timestamp) return null;
    
    const age = Date.now() - timestamp;
    if (age > this.CACHE_DURATION) {
      delete this.data[key];
      delete this.timestamps[key];
      return null;
    }
    
    return this.data[key];
  },
  
  clear(key) {
    if (key) {
      delete this.data[key];
      delete this.timestamps[key];
    } else {
      this.data = {};
      this.timestamps = {};
    }
  }
};

// ⚡ FONCTION DE DEBOUNCING
const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};



export { cache, debounce };
